import * as React from 'react';

import { IAppProvidersProps } from './types';

export class AppProviders extends React.PureComponent<IAppProvidersProps> {

	render() {
		return this.props.children;
	}

}
